// extracted by mini-css-extract-plugin
export default {"recipeImageText":"Cuisine_recipeImageText__AkBGN","recipeTitle":"Cuisine_recipeTitle__YTZrW","recipeAboveTitleText":"Cuisine_recipeAboveTitleText__DDOCX"};